import { startCase, toLower, replace } from 'lodash'

export function capitalCamel(string) {
    return(
        startCase(toLower(replace(string, new RegExp("_","g"), ' ')))
    )
}
